<template>
    <div class="row">
        <div class="col-12">
            <div class="styleguide__component_block">
                <div class="styleguide__component_header">
                    <h6>{{title}}</h6>
                </div>
                <div class="styleguide__component_content">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class StyleguideBlock extends Vue {
        @Prop({type: String})
        title;
    }
</script>



// WEBPACK FOOTER //
// src/components/general/StyleguideBlock.vue